import axios from "axios"

export const handleDashboard = (value) => {
  return async (dispatch) => {
    const newAxios = axios.create()
    const b_data = JSON.parse(localStorage.getItem("troiatec"))

    const b_response = await newAxios.get(`${process.env.REACT_APP_ADMIN_URL}/suscription/me`, {
      headers: {
        Authorization: `Bearer ${b_data.access_token}`
      }
    })
    dispatch({ type: 'HANDLE_DASHBOARD', value })

  }
}
export const handleCreditsCount = value => dispatch => dispatch({ type: 'HANDLE_CREDITS_COUNT', value })